import { Form, FormContext, Flex } from 'dash-ui';
import { ChangeEvent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';

const NameInput = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const valid = useValidation();

  const onChange =
    (fieldName: FormFields) => (e: ChangeEvent<HTMLInputElement>) => {
      stateHandlers[fieldName](e.target.value);
      valid(fieldName, e.target.value);
    };

  return (
    <Flex flex={1}>
      <Form.Group w="100%" flex={1}>
        <Form.Label>{t('forms:labels.nameOfProperty')}</Form.Label>
        <Form.Input
          value={formState.name || ''}
          placeholder={t('forms:placeholders.nameOfProperty') || ''}
          onChange={onChange(FormFields.Name)}
          $errorType={formErrors[FormFields.Name]?.type}
        />
        <Form.Feedback $errorType={formErrors[FormFields.Name]?.type}>
          {formErrors[FormFields.Name]?.message}
        </Form.Feedback>
      </Form.Group>
    </Flex>
  );
};

export default NameInput;
